import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Gear, Trash } from 'react-bootstrap-icons';
import './Node.css';

const CheckUserAttributeNode = ({ data, id, outputEdges, onEdgeCountChange }) => {
  // Define edge labels
  const edgeLabels = ['Yes', 'No'];

  // Define color schemes based on source
  const colors = {
    container: 'custom-node node-rounded-lg node-border-yellow',
    header: 'node-header node-bg-yellow-gradient node-border-yellow-bottom',
    text: 'node-text-yellow',
    handle: 'node-handle-small node-handle-yellow'
  };

  // Add hover state
  const [isHovered, setIsHovered] = React.useState(false);

  return (
    <div 
      className={`${colors.container} node-hover-lift`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div 
        className={`delete-btn delete-btn.top-center ${isHovered ? 'show' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          if (data.onDelete) {
            data.onDelete(id);
          }
        }}
      >
        <Trash className='icon-trash'/>
      </div>

      <div className={colors.header}>
        <div className="node-header-content">
          <Gear className='node-icon' style={{ color: '#f6971a' }}/>
          <span className={`node-title ${colors.text}`}>Check user attribute?</span>
        </div>
      </div>

      <Handle
        type="target"
        position={Position.Left}
        className={colors.handle}
      />

      <div className="node-output-handles">
        {Array.from({ length: outputEdges }).map((_, index) => (
          <div 
            key={`output-${index}`} 
            className="node-handle-container"
            style={{
              top: `${(index * 100) / (outputEdges - 1)}%`,
              transform: 'translateY(-50%)'
            }}
          >
            <Handle
              type="source"
              position={Position.Right}
              id={`output-${index}`}
              className={colors.handle}
            />
            <div 
              className={`node-edge-label ${colors.text} ${isHovered ? 'show' : ''}`}
              style={{
                left: '5px',
                top: '-6px',
              }}
            >
              {edgeLabels[index]}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CheckUserAttributeNode; 
